import React from 'react'
import PaymentSuccessful from './PaymentSuccessful';

function Index() {
 return <PaymentSuccessful/>

//   return (
//     <>
// {!paymentStatus ? <LoadingOutlined style={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'50%'}}/> : paymentStatus==='successful' ? <PaymentSuccessful/> :  <UnsuccessfulPaymentScreen/>}
// </>

//   )
}

export default Index